export default "__VITE_ASSET__rTPRI80$__"